// extracted by mini-css-extract-plugin
export var CustomLogo = "compare-price-module--CustomLogo--07845";
export var FreeShipLogo = "compare-price-module--FreeShipLogo--94c51";
export var PiecePrice = "compare-price-module--PiecePrice--e0ccb";
export var SavePrice = "compare-price-module--SavePrice--eadcc";
export var StartPrice = "compare-price-module--StartPrice--f04ba";
export var compareRow = "compare-price-module--compareRow--c7400";
export var strikeThrough = "compare-price-module--strikeThrough--0fc80";